/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Measure_Unit_Asin_OneInputs */

const en_measure_unit_asin_one = /** @type {(inputs: Measure_Unit_Asin_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} asin`)
};

const zh_hans1_measure_unit_asin_one = /** @type {(inputs: Measure_Unit_Asin_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个 ASIN`)
};

const pt_br2_measure_unit_asin_one = /** @type {(inputs: Measure_Unit_Asin_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ASIN`)
};

const es_measure_unit_asin_one = /** @type {(inputs: Measure_Unit_Asin_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ASIN`)
};

const fr_measure_unit_asin_one = /** @type {(inputs: Measure_Unit_Asin_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} asin`)
};

const de_measure_unit_asin_one = /** @type {(inputs: Measure_Unit_Asin_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ASIN`)
};

const ru_measure_unit_asin_one = /** @type {(inputs: Measure_Unit_Asin_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ASIN`)
};

const it_measure_unit_asin_one = /** @type {(inputs: Measure_Unit_Asin_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ASIN`)
};

/**
* | output |
* | --- |
* | "{count} asin" |
*
* @param {Measure_Unit_Asin_OneInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_unit_asin_one = /** @type {((inputs: Measure_Unit_Asin_OneInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Unit_Asin_OneInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_unit_asin_one(inputs)
	if (locale === "pt-BR") return pt_br2_measure_unit_asin_one(inputs)
	if (locale === "es") return es_measure_unit_asin_one(inputs)
	if (locale === "fr") return fr_measure_unit_asin_one(inputs)
	if (locale === "de") return de_measure_unit_asin_one(inputs)
	if (locale === "ru") return ru_measure_unit_asin_one(inputs)
	if (locale === "it") return it_measure_unit_asin_one(inputs)
	return en_measure_unit_asin_one(inputs)
});